import React, { useEffect, useState } from "react";
import { Checkbox, makeStyles } from "@material-ui/core";
import swal from "sweetalert2";
import { Row, Col, Form, Alert, Modal } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { DecryptData } from "../DatosEncriptados/EncryptedFunctions.js";
import {
  Box,
  Button,
  Input,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { ChevronLeft, ChevronRight, Search } from "react-bootstrap-icons";
import {
  ArrowDownward,
  Clear,
  FilterList,
  FirstPage,
  LastPage,
  ViewColumn,
} from "@material-ui/icons";
import { forwardRef } from "react";
import MaterialTable from "material-table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CheckRole from "../CheckRole.js";
import AADService from "../funcionesAuth.js";


function AlertDismissibleExample({ alerta }) {
  switch (alerta) {
    case 1:
      return <Alert variant="warning">Alerta</Alert>;
      break;
    case 2:
      return <Alert variant="success">Guardó exitosamente</Alert>;
      break;
    case 3:
      return <Alert variant="danger"></Alert>;
      break;
    case 4:
      return <Alert variant="warning">Error al enviar la información</Alert>;
      break;
    case 5:
      return <Alert variant="danger">Error en el servidor</Alert>;
      break;
    case 6:
      return (
        <Alert variant="warning">
          Ya existe una evaluación para el activo seleccionado
        </Alert>
      );
      break;
    default:
      return <p></p>;
      break;
  }
}
const NuevaOpcion = () => {
  const check = new CheckRole("/NuevaOpcion");
  const [nombreOpcion, setNombreOpcion] = useState("");
  const [padre, setPadre] = useState("");
  const [estadoPOST, setEstadoPost] = React.useState(0);
  
  const [orden, setOrden] = useState("");
  const [urlOpcion, setUrlOpcion] = useState("");
  const [menuType, setMenuType] = useState("");
  const [opcionesGenerales, setOpcionesGenerales] = useState([]);
  const [parentOptions, setOpciones] = useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();

  useEffect(() => {
    const getOptionTableData = async () => {
      const response = await fetch(process.env.REACT_APP_API_URL + `rolesId/0/`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      });
      let data = await response.json();
      let filteredData = data.filter((item) => item.padre === 0 || item.idopcion === 12);
      setOpciones(filteredData);
    };

    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "usuarios/menu/" +
          localStorage.getItem("usuario") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token, 
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "GET");
      if (validity) {
      }
    };
    getOptionTableData();
    fetchUsuario();
  }, []);

  const procesarDatos = async () => {
    const infoInforme = {
      opcion: document.getElementById("NombreOpcion")?.value,
      padre: parseInt(document.getElementById("Padre")?.value),
      orden: parseInt(document.getElementById("Orden")?.value),
      url_opcion: document.getElementById("UrlOpcion")?.value,
      disp_numerico1: parseInt(document.getElementById("MenuType")?.value),
    };
    let datos = JSON.stringify(infoInforme);

    fetch(process.env.REACT_APP_API_URL + "rolesId/0/" , {
      method: "POST",
      //responseType: "blob",
      body: datos,
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) =>
        response.json().then((data) => {
          if (response.status >= 200 && response.status < 300) {
            setEstadoPost(2);
          } else if (response.status >= 500) {
          } else if (response.status >= 400 && response.status < 500) {
            setEstadoPost(4);
          }
        })
      )
      .catch(function (err) {});
  }


  return (
    <Box p={4}>
      <AlertDismissibleExample alerta={estadoPOST} />
      <Box display="flex" justifyContent="space-between">
        <Box style={{ fontSize: "40px", fontWeight: "600" }}>Nueva Opción</Box>
        <Box display="flex" alignItems="center">
          <Box paddingRight={3}>
            <Link to='/opciones'>
              <Button
              style={{
                backgroundColor: "#ff7f41",
                color: "#fff",
                width: "100px",
                borderRadius: "5px",
                height: "40px",
              }}
            >
              Cancelar
            </Button>
            </Link>
          </Box>
          <Box>
            <Button
              style={{
                backgroundColor: "#00c389",
                color: "#fff",
                width: "100px",
                borderRadius: "5px",
                height: "40px",
              }}
              onClick={() => {procesarDatos();}}
            >
              Guardar
            </Button>
          </Box>
        </Box>
      </Box>
      <Box display="Columns" justifyContent="space-between" paddingTop={3}>
        <Row className="mb-3">
          <Box display="flex">
            <Col sm={7} xs={12}>
              <Box style={{ fontSize: "20px", fontWeight: "500" }}>
                Nombre de la opción
              </Box>
            </Col>
            <Col sm={7} xs={12}>
              <Box paddingLeft={3}>
                <Input
                  id="NombreOpcion"
                  type="text"
                  onChange={(e) => setNombreOpcion(e.target.value)}
                  fullWidth={true}
                />
              </Box>
            </Col>
          </Box>
        </Row>
        <br></br>
        <Row className="mb-3">
          <Box display="flex">
            <Col sm={7} xs={12}>
              <Box style={{ fontSize: "20px", fontWeight: "500" }}>
                Orden de la opción
              </Box>
            </Col>
            <Col sm={7} xs={12}>
              <Box paddingLeft={3}>
                <Input
                  id="Orden"
                  type="number"
                  onChange={(e) => setOrden(e.target.value)}
                  fullWidth={true}
                />
              </Box>
            </Col>
          </Box>
          <Col sm={12} xs={12}>
            <Box style={{ fontSize: "15px", fontWeight: "400", marginTop: "10px" }}>
              El orden 0 es para que no salga en los menús o submenús, son validaciones dentro de vistas.
            </Box>
          </Col>

        </Row>
        <br></br>
        <Row className="mb-3">
          <Box display="flex" alignItems="center">
            <Col sm={7} xs={12}>
              <Box style={{ fontSize: "20px", fontWeight: "500" }}>
                Selección del padre
              </Box>
            </Col>
            <Col sm={7} xs={12}>
              <FormControl variant="outlined" style={{ minWidth: 150 }}>
                <select
                  id="Padre"
                  onChange={(e) => setPadre(e.target.value)}
                  label="Seleccionar padre"
                >
                  {parentOptions.map((option) => (
                    <option key={option.idopcion} value={option.idopcion}>
                      {option.opcion}
                    </option>
                  ))}
                </select>
              </FormControl>
            </Col>
          </Box>
        </Row>
        <br></br>
        <Row className="mb-3">
          <Box display="flex" alignItems="center">
            <Col sm={7} xs={12}>
              <Box style={{ fontSize: "20px", fontWeight: "500" }}>
                Tipo del menú
              </Box>
            </Col>
            <Col sm={7} xs={12}>
              <FormControl variant="outlined" style={{ minWidth: 150 }}>
                <select
                  id="MenuType"
                  type="number"
                  onChange={(e) => setMenuType(e.target.value)}
                  label="Tipo de menú"
                >
                  <option>Seleccione una opcion</option>
                  <option value={0}>Menú:0</option>
                  <option value={1}>Submenu:1</option>
                </select>
              </FormControl>
            </Col>
          </Box>
          <Col sm={12} xs={12}>
            <Box style={{ fontSize: "15px", fontWeight: "400", marginTop: "10px" }}>
            La opcion 0 es para que aparezcan en el menu del inicio, y 1 para vistas dentro de las Evaluaciones.
            </Box>
          </Col>
        </Row>
        <br></br>
        <Row className="mb-3">
          <Box display="flex">
            <Col sm={7} xs={12}>
              <Box style={{ fontSize: "20px", fontWeight: "500" }}>
                URL Opción
              </Box>
            </Col>
            <Col sm={7} xs={12}>
              <Box paddingLeft={3}>
                <Input
                  id="UrlOpcion"
                  type="text"
                  sx={{ width: "250%" }}
                  onChange={(e) => setUrlOpcion(e.target.value)}
                />
              </Box>
            </Col>
          </Box>
        </Row>
      </Box>
    </Box>
  );
};

export default NuevaOpcion;
